import * as types from "../actions/types";

export const REASON_NOT_FOUND = 'NOT_FOUND';
export const REASON_CREATING_STUDENT = 'CREATING_STUDENT';
export const RECHECK_INTERVAL = 5000;

export const educationLevel = [
  { text: 'Less than high school', value: 'less_than_high_school'  },
  { text: 'High School Graduate', value: 'high_school' },
  { text: 'Some college', value: 'college'  },
  { text: 'College Graduate', value: 'college_graduate' },
  { text: 'Parent Unknown', value: 'parent_unknown'  }
];

export const ethnicities = [
  "Hispanic/Latino",
  "Mexican/Mexican-American/Chicano",
  "Central American",
  "South American",
  "Other Hispanic",
  "Asian Indian",
  "Chinese",
  "Japanese",
  "Korean",
  "Laotian",
  "Cambodian",
  "Vietnamese",
  "Filipino",
  "Other Asian",
  "Black/African American",
  "American Indian/Alaskan Native",
  "Guamanian",
  "Hawaiian",
  "Samoan",
  "Other Pacific Islander",
  "White"
];

export const statusTypes = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  DANGER: 'danger',
  INFO: 'info'
};

export const maritalOptions = [
  {
    value: 'S',
    text: 'Single'
  },
  {
    value: 'M',
    text: 'Married'
  },
  {
    value: 'E',
    text: 'Separated'
  },
  {
    value: 'D',
    text: 'Divorced'
  }
];

export const educationalGoalOptions = [
  {
    value: 'edGoalTransfer',
    text: 'Transfer'
  },
  {
    value: 'edGoalDegree',
    text: 'AA/AS Degree'
  },
  {
    value: 'edGoalCertificate',
    text: 'Certificate'
  }
];

export const invokeTypes = [
  {
    type: types.OPTIONS_REQUEST,
    message: 'Fetching Application Options'
  },
  {
    type: types.OPEN_TERM_REQUEST,
    message: 'Fetching Application Term'
  },
  {
    type: types.FETCH_USER_REQUEST,
    message: 'Fetching User Information'
  },
  {
    type: types.CREATE_APPLICATION_REQUEST,
    message: 'Creating Application'
  },
  {
    type: types.SUBMIT_APPLICATION_REQUEST,
    message: 'Submitting Application'
  },
  {
    type: types.CREATE_USER_REQUEST,
    message: 'Creating User Account'
  },
  {
    type: types.FETCH_APPLICATION_REQUEST,
    message: 'Fetching Application'
  }
];

export const messages = {
  AUTH_SUCCESS: 'Authenticated with Okta',
  AUTH_REQUEST: 'Authenticating with Okta',
  CREDENTIALS_REQUEST: 'Requesting credentials from AWS',
  CREDENTIALS_SUCCESS: 'Credentials received from AWS',
  LOGIN_COMPLETE: 'Login Complete'
};

export const APP_ENVIRONMENT = process.env.REACT_APP_API_STAGE;